import InspectionsPageTable from './InspectionsPageTable';

export default InspectionsPageTable;